import { Pipe, PipeTransform } from '@angular/core';
import { ProjectChannel } from 'sustainment-component';

@Pipe({
    name: 'filterProjectMembers',
    pure: true,
    standalone: false
})
export class FilterProjectMembersPipe implements PipeTransform {
  public transform(items: ProjectChannel[]): {
    shortList: ProjectChannel[];
    requestsToJoin: ProjectChannel[];
  } {
    return items.reduce(
      (result, channel) => {
        if (channel.opportunityRequestId) {
          result.requestsToJoin.push(channel);
        } else {
          result.shortList.push(channel);
        }
        return result;
      },
      { shortList: [], requestsToJoin: [] } as {
        shortList: ProjectChannel[];
        requestsToJoin: ProjectChannel[];
      }
    );
  }
}
